module.exports = __webpack_public_path__ + "static/img/2030.a170d73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2030.jpg
// module id = 320
// module chunks = 0